import { createContext } from 'react';
import {
    QUERY_KEYS_IGD,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useIgdFiltersContext } from '../../../Common/Filters/hooks/useIgdFiltersContext';

export const ValuesChartsDataContext = createContext();

const ValuesChartsDataProvider = ({ children }) => {
    const { filters } = useIgdFiltersContext();

    const filterParams = {
        year: filters.year?.value || '',
        month: filters.month?.value || '',
        location: filters.unidade.value,
        city: filters.cidade?.value,
    };

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_IGD.VALUES_RESULTS,
            url: 'governanceroom/socialdashboard/igd/values/withoutIncentives',
        },
        filterParams
    );

    const totalIncentivesData = useChartsData(
        {
            key: QUERY_KEYS_IGD.TOTAL_INCENTIVES,
            url: 'governanceroom/socialdashboard/igd/values/totalIncentives',
        },
        filterParams
    );

    const calculatedValueWithIncentivesData = useChartsData(
        {
            key: QUERY_KEYS_IGD.CALCULATED_VALUE_WITH_INCENTIVES,
            url: 'governanceroom/socialdashboard/igd/values/calculatedValueWithIncentives',
        },
        filterParams
    );

    const transferValueComparisonData = useChartsData(
        {
            key: QUERY_KEYS_IGD.TRANSFER_VALUE_COMPARISON,
            url: 'governanceroom/socialdashboard/igd/values/transferValueComparison',
        },
        filterParams
    );

    const transferValueComparisonPercentualData = useChartsData(
        {
            key: QUERY_KEYS_IGD.TRANSFER_VALUE_COMPARISON_PERCENTUAL,
            url: 'governanceroom/socialdashboard/igd/values/transferValueComparisonPercentage',
        },
        filterParams
    );

    const chartData = {
        withoutIncentivesAnual: data?.anualEvolution ?? [],
        withoutIncentivesMonth: data?.monthEvolution ?? [],
        totalIncentivesAnual: totalIncentivesData?.data?.anualEvolution ?? [],
        totalIncentivesMonth: totalIncentivesData?.data?.monthEvolution ?? [],
        calculatedValueWithIncentivesAnual: calculatedValueWithIncentivesData?.data?.anualEvolution ?? [],
        calculatedValueWithIncentivesMonth: calculatedValueWithIncentivesData?.data?.monthEvolution ?? [],
        transferValueComparisonAnual: transferValueComparisonData?.data?.anualEvolution ?? [],
        transferValueComparisonMonth: transferValueComparisonData?.data?.monthEvolution ?? [],
        transferValueComparisonPercentualAnual: transferValueComparisonPercentualData?.data?.anualEvolution ?? [],
        transferValueComparisonPercentualMonth: transferValueComparisonPercentualData?.data?.monthEvolution ?? []
    };

    return (
        <ValuesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </ValuesChartsDataContext.Provider>
    );
};

export default ValuesChartsDataProvider;
